import http from "../helpers/http-common"

class AIGeneratorService {

    search(params) {
        return http.post(`/ai-generator/search`, params);
    }

    getStats(params) {
        return http.post(`/ai-generator/stats`, params);
    }

    getAutoStats(params) {
        return http.post(`/ai-generator/auto-stats`, params);
    }

    getUsersThreads(params) {
        return http.post(`/ai-generator/threads`, params);
    }

    getAutoThreads(params) {
        return http.post(`/ai-generator/auto-threads`, params);
    }

    showThread(params) {
        return http.post(`/ai-generator/thread`, params);
    }

    closeThread(params) {
        return http.post(`/ai-generator/thread-close`, params);
    }

    disableUser(params) {
        return http.post(`/ai-generator/thread-user-close`, params);
    }

    generateMessage(params) {
        return http.post(`/ai-generator/generate-message`, params);
    }

    generateMessageTerminate(params) {
        return http.post(`/ai-generator/generate-message-terminate`, params);
    }

    addMessage(params) {
        return http.post(`/ai-generator/add-message`, params);
    }

    validateMessage(params) {
        return http.post(`/ai-generator/validate-message`, params);
    }

    deleteMessage(params) {
        return http.post(`/ai-generator/delete-message`, params);
    }

    getAssistants() {
        return http.get(`/ai-generator/assistants/list`);
    }

    updateAssistant(params) {
        return http.post(`/ai-generator/assistants/update`, params);
    }


    /**
     * TEST AI Methods
     */

    getAssistantsTEST() {
        return http.get(`/ai-generator/assistants-test/list`);
    }

    updateAssistantTEST(params) {
        return http.post(`/ai-generator/assistants-test/update`, params);
    }

    getThreads(params) {
        return http.post(`/ai-generator/threads-test/list`, params);
    }

    sendMessageTest(params) {
        return http.post(`/ai-generator/messages-test/send`, params);
    }

    sendMessageTestAndGenerate(params) {
        return http.post(`/ai-generator/messages-test/generate`, params);
    }

    getMessages(params) {
        return http.post(`/ai-generator/messages-test/list`, params);
    }

    deleteThread(params) {
        return http.post(`/ai-generator/threads-test/delete`, params);
    }
}

export default new AIGeneratorService();
